import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'HomeNavigationStore' })
export default class HomeNavigationStore extends VuexModule {
  private navigationDrawerDefault: boolean | null = null
  public navigationDrawer: boolean | null = this.navigationDrawerDefault

  @Mutation
  setNavigationDrawer(value: boolean | null) {
    this.navigationDrawer = value
  }

  @Mutation
  clearNavigationDrawer() {
    this.navigationDrawer = this.navigationDrawerDefault
  }
}
